import calculatePriceIncrement from './collaborators/calculate-price-increment';
import formatPriceForDisplay from './collaborators/format-price-for-display';
import getMaxSelectionOptions from './collaborators/get-max-selection-options';
import getMinSelectionOptions from './collaborators/get-min-selection-options';
import roundMaxPriceToNextIncrement
  from './collaborators/round-max-price-to-next-increment';
import roundMinPriceToPreviousIncrement
  from './collaborators/round-min-price-to-previous-increment';

const setFacetDisplayProps = facet => {
  if (facet.isSelected && facet.shouldShow) {
    const displayName = formatPriceForDisplay(facet.appliedRange, facet.range);
    facet.hasTags = true;
    facet.tagDisplayLabel = displayName;
    facet.searchFacetOptionValue = displayName;
  }
}

const priceFacetOptionIds = {
  MIN: (facet, option) => {
    facet.range.min = Math.floor(Number(option.searchFacetOptionValue));
  },
  MAX: (facet, option) => {
    facet.range.max = Math.ceil(Number(option.searchFacetOptionValue));
  },
  MIN_SELECTED: (facet, option) => {
    facet.appliedRange.min = Math.floor(
      Number(option.searchFacetOptionValue)
    );
    facet.isSelected = true;
  },
  MAX_SELECTED: (facet, option) => {
    facet.appliedRange.max = Math.ceil(
      Number(option.searchFacetOptionValue)
    );
    facet.isSelected = true;
  },
}

const priceFacetAdaptor = facet => {
  const facetOptions = facet.searchFacetOptionGroupList &&
      facet.searchFacetOptionGroupList.searchFacetOptionList;
  facet.type = 'range';
  facet.range = {};
  facet.appliedRange = {};
  facet.isSelected = false;

  facetOptions.map(option => {
    const setFacetPriceRangeFn = Object.keys(priceFacetOptionIds)
      .filter(priceFacetOptionId =>  priceFacetOptionId == option.searchFacetOptionId)
      .reduce((prev, optionId) => {return priceFacetOptionIds[optionId]}, () => {});
    setFacetPriceRangeFn(facet, option);
  });

  const increment = calculatePriceIncrement(facet.range.min, facet.range.max);
  facet.minOptions = getMinSelectionOptions(facet.appliedRange, facet.range, increment);
  facet.maxOptions = getMaxSelectionOptions(facet.appliedRange, facet.range, increment);
  facet.range.min = roundMinPriceToPreviousIncrement(facet.appliedRange, facet.range, increment);
  facet.range.max = roundMaxPriceToNextIncrement(facet.appliedRange, facet.range, increment);
  facet.shouldShow = facet.range.max - facet.range.min >= increment;
  setFacetDisplayProps(facet);

  return facet;
};

export default priceFacetAdaptor;